module.exports = __webpack_public_path__ + "img/racecourse-kenilworth-turf-1000.d216fa1e.svg";